{
  "name": "@workday/canvas-kit-mcp",
  "version": "16.1.1",
  "description": "MCP package for Canvas Kit",
  "author": "Workday, Inc. (https://www.workday.com)",
  "license": "Apache-2.0",
  "sideEffects": false,
  "repository": {
    "type": "git",
    "url": "https://github.com/Workday/canvas-kit.git",
    "directory": "modules/mcp"
  },
  "bin": {
    "canvas-kit-mcp": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./dist/types/index.d.ts",
      "default": "./dist/index.js"
    },
    "./lib": {
      "types": "./dist/types/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "main": "./dist/index.js",
  "types": "./dist/types/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "build:discover": "tsx ./build/discover-stories.ts",
    "build:indexes": "tsx ./build/generate-indexes.ts",
    "build:indexes:dist": "MCP_CATALOG_OUTPUT_DIR=dist/lib tsx ./build/generate-indexes.ts",
    "build:apps": "tsx ./build/build-story-apps.ts",
    "build:copy": "tsx ./build/index.ts",
    "build:types": "tsc --project tsconfig.build.json -d true --declarationDir dist/types --emitDeclarationOnly --pretty",
    "build:mcp": "esbuild lib/index.ts --bundle --platform=node --packages=external --outfile=dist/index.js --format=esm --sourcemap && esbuild lib/cli.ts --bundle --platform=node --packages=external --outfile=dist/cli.js --format=esm --sourcemap",
    "build": "npm-run-all build:discover build:indexes:dist build:apps build:copy build:types build:mcp",
    "test:catalog": "node --import tsx --test spec/*.spec.ts",
    "clean": "rimraf dist && rimraf .build-info && mkdirp dist"
  },
  "keywords": [
    "canvas",
    "canvas-kit",
    "workday",
    "mcp"
  ],
  "dependencies": {
    "@modelcontextprotocol/ext-apps": "^1.3.2",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@mdx-js/react": "^3.1.0",
    "@mdx-js/rollup": "^3.1.0",
    "@types/node": "^22.0.0",
    "@vitejs/plugin-react": "^4.3.0",
    "esbuild": "^0.28.1",
    "glob": "^10.5.0",
    "mkdirp": "^1.0.3",
    "remark-gfm": "^4.0.0",
    "rimraf": "^5.0.0",
    "tsx": "^4.7.0",
    "typescript": "5.0",
    "vite": "^5.0.0",
    "vite-plugin-singlefile": "^2.0.0"
  }
}
